import { ThunkDispatch, UnknownAction } from '@reduxjs/toolkit';

import {
  courseStepsApi,
  getCourseStepTag,
  courseStepsTagType,
  getCourseStepsFieldSourcesTag,
  courseStepsFieldSourcesListTag,
} from './index';

interface OnQueryStartedArgs {
  getState: () => unknown;
  queryFulfilled: Promise<unknown>;
  dispatch: ThunkDispatch<any, any, UnknownAction>;
}

/**
 * Invalidates course step and field source caches after a successful mutation.
 *
 * Note: `getState` is cast to `any` internally because importing `RootState`
 * from the store would create a circular dependency
 * (store → forms/resources → this helper → store).
 */
export async function invalidateCourseStepCaches(
  courseStepId: string | null | undefined,
  { dispatch, getState, queryFulfilled }: OnQueryStartedArgs
): Promise<void> {
  try {
    await queryFulfilled;

    if (!courseStepId) return;

    const stepDetails = courseStepsApi.endpoints.details.select({
      id: courseStepId,
    })(getState() as any);
    const courseId = stepDetails?.data?.courseId;

    dispatch(
      courseStepsApi.util.invalidateTags(
        courseId
          ? [
              getCourseStepTag(courseStepId),
              getCourseStepsFieldSourcesTag(courseId),
            ]
          : [getCourseStepTag(courseStepId), courseStepsFieldSourcesListTag]
      )
    );
  } catch {
    dispatch(courseStepsApi.util.invalidateTags([courseStepsTagType]));
  }
}
